import {

    //GET_CARGUES,
    //GET_STATE_LOADING

  } from "@/views/cargues/store/types/types.js";

const  getters= {
    //[GET_CARGUES]: state => state.cargues,
    //[GET_STATE_LOADING]: state => state.loading,
}

export default getters